<ng-container *ngIf="!featureFlagMobileNavTabsEnabled; else navTabsVersion">
  <ng-content></ng-content>
</ng-container>

<ng-template #navTabsVersion>
  <ng-content select="[navTabs]"></ng-content>
</ng-template>
